import React, { FC } from 'react'
import SALink from 'components/SALink'
import styles from './SeeMoreTile.module.scss'

type SeeMoreTileProps = {
  link: string
  title: string
}

const SeeMoreTile: FC<SeeMoreTileProps> = ({ link, title }) => {
  return (
    <div className={styles.carouselPolaroidBox}>
      <SALink data-type='see-more' href={link} title={title}>
        <div className={styles.carouselPolaroid}>
          <p>See More Art</p>
        </div>
      </SALink>
    </div>
  )
}

export default SeeMoreTile
